export default __webpack_public_path__ + "static/media/error.b18a756c.png";